import { configureStore } from '@reduxjs/toolkit';
import eventReducer from './eventSlice';
import exhibitorReduser from './exhibitorSlice';
import filterReducer from './filterSlice';
import favoritesReducer from './favoritesSlice';
import categoriesReduser from './categoriesSlice';

export default configureStore({
    reducer: {
        event: eventReducer,
        exhibitor: exhibitorReduser,
        filter: filterReducer,
        favorites: favoritesReducer,
        categories: categoriesReduser,
    }
});
